var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "business_center_FILL1_wght300_GRAD0_opsz48 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.6827 6.31703V4.42667C8.6827 4.03452 8.82505 3.6961 9.10975 3.4114C9.39443 3.12672 9.73285 2.98438 10.125 2.98438H13.875C14.2671 2.98438 14.6055 3.12672 14.8902 3.4114C15.1749 3.6961 15.3173 4.03452 15.3173 4.42667V6.31703H20.0576C20.4498 6.31703 20.7882 6.45938 21.0729 6.74408C21.3576 7.02876 21.5 7.36718 21.5 7.75933V13.417H13.9672V12.0324H10.0635V13.417H2.5V7.75933C2.5 7.36718 2.64235 7.02876 2.92705 6.74408C3.21175 6.45938 3.55018 6.31703 3.94233 6.31703H8.6827ZM9.8173 6.31703H14.1827V4.42667C14.1827 4.34974 14.1506 4.27923 14.0865 4.21513C14.0224 4.15101 13.9519 4.11895 13.875 4.11895H10.125C10.0481 4.11895 9.97755 4.15101 9.91345 4.21513C9.84935 4.27923 9.8173 4.34974 9.8173 4.42667V6.31703ZM11.1981 14.8016V13.167H12.8327V14.8016H11.1981ZM2.5 14.5516H10.0635V15.9362H13.9672V14.5516H21.5V19.042C21.5 19.4341 21.3576 19.7725 21.0729 20.0572C20.7882 20.3419 20.4498 20.4843 20.0576 20.4843H3.94233C3.55018 20.4843 3.21175 20.3419 2.92705 20.0572C2.64235 19.7725 2.5 19.4341 2.5 19.042V14.5516Z",
    fill: "#BC172F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusiness);
export default __webpack_public_path__ + "static/media/business.062b94053836720295e642d76db326cb.svg";
export { ForwardRef as ReactComponent };